const normalizeSelector = s => s.replace(/\s+/g, ' ').trim()

export const parseRules = css => {
  if (!css) return []
  const rules = []
  let depth = 0
  let buf = ''
  let selector = ''
  for (let i = 0; i < css.length; i += 1) {
    const c = css[i]
    if (c === '{' && depth === 0) {
      selector = buf.trim()
      buf = ''
      depth = 1
    } else if (c === '{') {
      depth += 1
      buf += c
    } else if (c === '}' && depth === 1) {
      if (selector) rules.push({ selector, body: buf.trim() })
      buf = ''
      selector = ''
      depth = 0
    } else if (c === '}') {
      depth -= 1
      buf += c
    } else {
      buf += c
    }
  }
  return rules
}

export const stringifyRules = rules => rules.map(r => `${r.selector} { ${r.body} }`).join('\n\n')

export const mergeCss = (existing, incoming) => {
  const incomingRules = parseRules(incoming)
  if (incomingRules.length === 0) return existing || ''
  const existingRules = parseRules(existing)
  const overrideSet = new Set(incomingRules.map(r => normalizeSelector(r.selector)))
  const kept = existingRules.filter(r => !overrideSet.has(normalizeSelector(r.selector)))
  return stringifyRules([...kept, ...incomingRules])
}
